export default __webpack_public_path__ + "static/media/email-fail.8fc0355b.svg";